<template>
  <v-app id="inspire">
    <appdrawer />
    <v-content>
      <router-view/>
    </v-content>
    <dialogs-wrapper/>
  </v-app>
</template>

<script>
import AppDrawer from '@/components/AppDrawer'

export default {
  name: 'Home',
  components: {
    appdrawer: AppDrawer,
  },
}
</script>

<style>
  .content--wrap {
    background: #fff;
  }
</style>
